var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coupon-section"},[(_vm.popup)?_c('div',[_c('WizardForm',{attrs:{"popup":_vm.popup},on:{"popup-changed":_vm.popupChanged}})],1):_c('div',{staticClass:"text-center"},[_c('b-spinner')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }